// extracted by mini-css-extract-plugin
export var columnList = "_fj-0";